import $ from 'jquery'
import { isSP } from '../modules/checkScreen'

const createImageBg = () => {
  const $target = $('.js-article-image')
  const BG_CLASS = 'box-bg'
  const CAPTION_CLASS = 'caption'

  if (!$target.length) {
    return
  }

  const setPosition = () => {
    $target.each((index, el) => {
      const $this = $(el)
      const $boxBg = $this.find(`.${BG_CLASS}`)
      const $caption = $this.find(`.${CAPTION_CLASS}`)

      if (isSP()) {
        $boxBg.removeAttr('style')
        $caption.removeAttr('style')
        return
      }

      const left = $this.offset().left * -1
      $boxBg.css({ left })
      $caption.css({ left })
    })
  }

  $target.each((index, el) => {
    const $this = $(el)
    const $boxBg = $('<span />', { class: BG_CLASS })
    $this.append($boxBg)
  })

  $(window).on('load resize', setPosition)

  setPosition()
}

const setLeftBgHeight = () => {
  const $boxArticle = $('.p-article-detail')
  const inconvenienceClass = ('-inconvenience')
  const $boxInfo = $('.box-content').children('.box-info')
  let $inconvenienceHeight = 0

  if (!$boxArticle.length || !$boxInfo.length) {
    return
  }

  if ($boxArticle.hasClass(inconvenienceClass)) {
    $inconvenienceHeight = 65
  }

  const offsetTop = $boxInfo.offset().top + 113 + $inconvenienceHeight
  const $style = $('<style>').html(`.p-article-detail::before { height: ${offsetTop}px; }`)
  $('html').find('head').append($style)
}

const initDetail = () => {
  createImageBg()
  setLeftBgHeight()
}

export default initDetail
